export * from './slider.model';
export * from './home.model';
export * from './benefit-section.model';
export * from './login-section.model';
export * from './links.model';
